import {
  type CivilDate,
  civilDateToDate,
  compareCivilDate,
  dateToCivilDate,
} from '~/models/civilDate'
import { addDays } from '~/models/dateTime'

/** 契約電力の期間: `start` から `kw`。 最初の期間の `start` は供給開始日。 期間は次の期間の前日まで。 */
export type KwPeriod = { start: CivilDate; kw: string }

/** 1 契約の契約電力の変更 (最初の期間より後の期間) の上限 (backend の `KwPeriodsMaxCount`、 判断台帳 R61)。 */
export const KW_PERIODS_MAX_COUNT = 120

/** 前の日。 */
export const dayBefore = (date: CivilDate): CivilDate =>
  dateToCivilDate(addDays(civilDateToDate(date), -1))

/** 今日より後に始まる期間を開始日順に全部 (最初の期間は変更ではないので渡さない)。 契約推移の「予定あり」の印と hover に使う。 */
export const upcomingKwChanges = (
  periods: KwPeriod[],
  today: CivilDate,
): KwPeriod[] =>
  periods
    .filter((p) => compareCivilDate(p.start, today) > 0)
    .sort((a, b) => compareCivilDate(a.start, b.start))
